export default __webpack_public_path__ + "static/media/ArrowNew.d58c6f8f.png";